import React, { useState } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { AIChat } from "./AIChat";
import { BookingCheckModal } from "./BookingCheckModal";

interface LayoutProps {
  children: React.ReactNode;
  onCheckBookingOpen?: (setter: (open: boolean) => void) => void;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  onCheckBookingOpen,
}) => {
  const [isCheckBookingOpen, setIsCheckBookingOpen] = useState(false);

  // Pass the setter to children if they need it
  React.useEffect(() => {
    if (onCheckBookingOpen) {
      onCheckBookingOpen(setIsCheckBookingOpen);
    }
  }, [onCheckBookingOpen]);

  return (
    <div className="min-h-screen font-sans bg-gray-50 flex flex-col">
      <Navigation setIsCheckBookingOpen={setIsCheckBookingOpen} />
      <main className="flex-grow">
        {React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement<any>, {
              setIsCheckBookingOpen,
            })
          : children}
      </main>
      <Footer />
      <AIChat />
      <BookingCheckModal
        isOpen={isCheckBookingOpen}
        onClose={() => setIsCheckBookingOpen(false)}
      />
    </div>
  );
};
